import React, {createContext, Dispatch, SetStateAction, useMemo, useState} from 'react';
import {FabricObject} from '~/common/fabric/types';
import {useVideoControl} from '~/common/hooks/useVideoControls';
import {OverlayVideo} from '~/QuickEcards/components/OverlayAnimation/OverlayAnimation';

type EcardContextProps = {
  setCanvas: (prevCanvas: unknown) => void;
  canvas: unknown;
  activeObjects: unknown[];
  setActiveObjects: Dispatch<SetStateAction<FabricObject[]>>;
  effectVideo: OverlayVideo | null;
  revealVideo: OverlayVideo | null;
};

const defaultContextValue: EcardContextProps = {
  // biome-ignore lint/suspicious/noEmptyBlockStatements: existing error
  setCanvas: () => {},
  canvas: null,
  activeObjects: [],
  // biome-ignore lint/suspicious/noEmptyBlockStatements: existing error
  setActiveObjects: () => {},
  effectVideo: null,
  revealVideo: null,
};

export const EcardContext = createContext<EcardContextProps>(defaultContextValue);

export const EcardContextParent = ({children}: {children: React.ReactNode}) => {
  const [canvas, setCanvas] = useState<unknown>();
  const [activeObjects, setActiveObjects] = useState<FabricObject[]>([]);
  const effectVideo = useVideoControl();
  const revealVideo = useVideoControl();

  const context = useMemo(
    () => ({
      canvas,
      setCanvas,
      activeObjects,
      setActiveObjects,
      effectVideo,
      revealVideo,
    }),
    [canvas, activeObjects, effectVideo, revealVideo]
  );

  return <EcardContext.Provider value={context}>{children}</EcardContext.Provider>;
};
